import { Controller } from "stimulus";
import BootstrapNavTabs from "../../entrypoints/src/admin/components/bootstrap_nav_bars";

export default class extends Controller {
  connect() {
    BootstrapNavTabs.mergeCustomFeatures(this.element);

    this.element.querySelectorAll('[data-src]').forEach((el) => {
      el.addEventListener('click', (ev) => {
        this.loadFrame(el)
      });
      el.classList.contains('active') && this.loadFrame(el);
    });
  }

  loadFrame(el) {
    if (!!el.dataset.clicked) return;

    el.dataset.clicked = 'true';
    document.querySelector(el.dataset.elementTarget).setAttribute('src', el.dataset.src);
  }
};